module.exports = __webpack_public_path__ + "img/water.88ffdeee.png";